import auth from "./server/auth.js";
import mine from "./server/mine.js";
import oauth from "./server/oauth.js";
import appUser from "./server/appUser.js";
import servicer from "./server/servicer.js";
import admin from "./server/admin.js";

export default {
    auth,
    mine,
    oauth,
    appUser,
    servicer,
    admin
};